export default __webpack_public_path__ + "static/media/7.3.55000035.mp4";